// @noflow
import { SpinnerWrapperBottom, SpinnerWrapperTop } from './styles';

import CoolingSpinner from '../cooling';
import { debounce } from 'lodash/fp';
import HeatingSpinner from '../heating';
import PropTypes from 'prop-types';
import * as React from 'react';

export default class DualTemperatureSpinner extends React.Component {
    static propTypes = {
        comfortZone: PropTypes.number,
        coolTemperature: PropTypes.number.isRequired,
        disabled: PropTypes.bool,
        handleChangeTemp: PropTypes.func,
        heatTemperature: PropTypes.number.isRequired,
        isUpdating: PropTypes.bool,
        mode: PropTypes.arrayOf(PropTypes.string).isRequired
    };

    state = {
        coolHovered: false,
        heatHovered: false
    };

    handleCoolHovered = state => {
        this.setState({
            coolHovered: state
        });
    };

    handleHeatHovered = state => {
        this.setState({
            heatHovered: state
        });
    };

    coolHoverOver = () => this.handleCoolHovered(true);
    coolHoverOut = () => this.handleCoolHovered(false);
    coolTouched = () => {
        this.handleCoolHovered(true);
        this.handleHeatHovered(false);
    };

    heatHoverOver = () => this.handleHeatHovered(true);
    heatHoverOut = () => this.handleHeatHovered(false);
    heatTouched = () => {
        this.handleHeatHovered(true);
        this.handleCoolHovered(false);
    };

    resetState = debounce(1000, () => {
        this.handleCoolHovered(false);
        this.handleHeatHovered(false);
    });

    handleCoolingChange = temp => {
        const { heatTemperature, handleChangeTemp, mode, comfortZone: minDifference } = this.props;
        const [heat, cool] = mode;
        handleChangeTemp(temp, cool);
        if (heatTemperature > temp - minDifference) {
            handleChangeTemp(temp - minDifference, heat);
        }
    };

    handleHeatingChange = temp => {
        const { coolTemperature, handleChangeTemp, mode, comfortZone: minDifference } = this.props;
        const [heat, cool] = mode;
        handleChangeTemp(temp, heat);
        if (coolTemperature < temp + minDifference) {
            handleChangeTemp(temp + minDifference, cool);
        }
    };

    render() {
        const {
            coolTemperature,
            heatTemperature,
            mode,
            minCool,
            maxCool,
            minHeat,
            maxHeat,
            isUpdating,
            disabled
        } = this.props;

        const [heat, cool] = mode;
        const { coolHovered, heatHovered } = this.state;

        return (
            <div>
                <SpinnerWrapperTop
                    heatHovered={heatHovered}
                    isUpdating={isUpdating}
                    mouseOver={coolHovered}
                    onBlur={this.coolHoverOut}
                    onFocus={this.coolHoverOver}
                    onMouseOut={this.coolHoverOut}
                    onMouseOver={this.coolHoverOver}
                    onTouchEnd={this.resetState}
                    onTouchStart={this.coolTouched}
                >
                    <CoolingSpinner
                        currentTemp={coolTemperature}
                        disabled={disabled}
                        handleChangeTemp={this.handleCoolingChange}
                        isSingleBGColorOnly
                        isUpdating={isUpdating}
                        maxCool={maxCool}
                        minCool={minCool}
                        mode={cool}
                    />
                </SpinnerWrapperTop>
                <SpinnerWrapperBottom
                    coolHovered={coolHovered}
                    isUpdating={isUpdating}
                    mouseOver={heatHovered}
                    offsetTop
                    onBlur={this.heatHoverOut}
                    onFocus={this.heatHoverOver}
                    onMouseOut={this.heatHoverOut}
                    onMouseOver={this.heatHoverOver}
                    onTouchEnd={this.resetState}
                    onTouchStart={this.heatTouched}
                >
                    <HeatingSpinner
                        currentTemp={heatTemperature}
                        disabled={disabled}
                        handleChangeTemp={this.handleHeatingChange}
                        isDualSpinner
                        isSingleBGColorOnly
                        isUpdating={isUpdating}
                        maxHeat={maxHeat}
                        minHeat={minHeat}
                        mode={heat}
                    />
                </SpinnerWrapperBottom>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/dual-spinner/index.js